import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import { Box, Chip, Collapse } from "@mui/material";
import React from "react";

import theme from "@/theme/theme.tsx";
import { lowerCaseToCapCase } from "@/utils";

export default React.memo(function SelectGroupsOfFeeds({
  data,
  index,
  openGroups,
  toggleOpenGroup,
  toggleAllGroupFeeds,
  activeChannels,
  toggleSingleFeed,
  containerClassList,
}: {
  data: any;
  index: number;
  openGroups: string[];
  toggleOpenGroup: (value: string) => void;
  toggleAllGroupFeeds: (value: string[]) => void;
  activeChannels: string[];
  toggleSingleFeed: (value: string) => void;
  containerClassList: { active: object; inactive: object };
}) {
  const activeClass = (data: { id: string }[]) =>
    data?.some((feed) => activeChannels.includes(feed.id)) ? containerClassList.active : containerClassList.inactive;

  return (
    <Box key={`select-groups-of-feeds-${index}`}>
      {data?.length > 0 && (
        <Box>
          {data.map((group) => (
            <Box key={group.id} sx={{ mb: 2, ...activeClass(group.feeds) }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    cursor: "pointer",
                    alignItems: "center",
                    gap: 1,
                  }}
                  onClick={() => toggleOpenGroup(group.id)}
                >
                  <Box sx={{ display: "flex" }}>
                    {openGroups.includes(group.id) ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                  </Box>
                  <Box sx={{ fontWeight: "bold", display: "flex" }}>
                    {group.name} ({group.feeds.length})
                  </Box>
                </Box>
              </Box>
              <Collapse in={openGroups.includes(group.id)}>
                <Box sx={{ mt: 1, p: 1 }}>
                  {group?.feeds?.length > 1 && (
                    <Box
                      onClick={() => toggleAllGroupFeeds(group.feeds.map((feed) => feed.id))}
                      sx={{ display: "flex", gap: 2 }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          cursor: "pointer",
                          gap: 1,
                          ml: 0.5,
                          mb: 1,
                        }}
                      >
                        {activeChannels.some((feedId) => group.feeds.map((feed) => feed.id).includes(feedId)) ? (
                          <>
                            <Box sx={{ display: "flex" }}>
                              <CheckBoxIcon sx={{ color: theme.palette.info.main }} />
                            </Box>
                            <Box>De-Select All</Box>
                          </>
                        ) : (
                          <>
                            <Box sx={{ display: "flex" }}>
                              <CheckBoxOutlineBlankIcon
                                sx={{
                                  color: theme.palette.brand.other.gray.main,
                                }}
                              />
                            </Box>
                            <Box>Select All</Box>
                          </>
                        )}
                      </Box>
                    </Box>
                  )}
                  {group.feeds.map((feed, index) => (
                    <div key={`${group.id}-feed-container-${feed.id}-${index}`}>
                      <button
                        className="basic-button"
                        key={`${group.id}-${feed.id}-${index}`}
                        style={{
                          width: "100%",
                          marginBottom: 1,
                        }}
                        onClick={() => toggleSingleFeed(feed.id)}
                      >
                        {activeChannels?.includes(feed.id) ? (
                          <CheckBoxIcon sx={{ color: theme.palette.info.main }} />
                        ) : (
                          <CheckBoxOutlineBlankIcon sx={{ color: theme.palette.brand.other.gray.main }} />
                        )}

                        <Box
                          sx={{
                            display: "flex",
                            width: "100%",
                            gap: 1,
                          }}
                        >
                          <Box
                            sx={{
                              pt: feed?.commandAlias?.length ? 2 : 0,
                            }}
                          >
                            <Box
                              sx={{
                                flexGrow: 1,
                                textAlign: "left",
                              }}
                            >
                              {feed.title}
                            </Box>

                            {feed?.commandAlias?.length > 0 && (
                              <Box
                                sx={{
                                  display: "flex",
                                  fontSize: "10px",
                                  gap: 1,
                                }}
                              >
                                {feed?.commandAlias.map((alias) => (
                                  <Chip
                                    key={alias.id}
                                    label={lowerCaseToCapCase(alias.alias)}
                                    size="small"
                                    sx={{
                                      py: 0.15,
                                      width: "auto",
                                      height: "auto",
                                      background: theme.palette.info.main,
                                    }}
                                  />
                                ))}
                              </Box>
                            )}
                          </Box>
                        </Box>
                      </button>
                    </div>
                  ))}
                </Box>
              </Collapse>
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
});
